import React, { FunctionComponent } from 'react';
import { IRefReqCandidateForm } from '../../../../common/models/referenceRequest/IRefReqCandidateForm';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Exclamation } from '../../../../assets/icons/exclamation.svg';
import { ReactComponent as Check } from '../../../../assets/icons/check.svg';
import { ReferenceType } from '../../../../common/enums/ReferenceType';
import { IFormattedMessage } from '../../../../common/models/common/IFormattedMessage';
import { IReferenceCandidateForm } from '../../../../common/models/reference/IReferenceCandidateForm';
import styles from './styles.module.scss';

export enum Pages {
  CheckCode = 'CheckCode',
  Intro = 'Intro',
  ConsentWaiver = 'Consent Waiver',
  PhoneNumber = 'Phone Number',
  ReferenceForm = 'ReferenceForm',
  FinalizePage = 'FinalizePage',
  PreviewEmail = 'PreviewEmail',
  ThankYouScreen = 'ThankYouScreen',
  RefProgressPage = 'RefProgressPage',
  EditReference = 'EditReference'
}

export enum RefFormPages {
  Overview = 'Overview',
  ReferenceRole = 'ReferenceRole',
  ReferenceName = 'ReferenceName',
  ReferenceContactInfo = 'ReferenceContactInfo',
  ReferenceCommonCompany = 'ReferenceCommonCompany',
  Final = 'Final'
}

export const getDefaultPage = (refReq: IRefReqCandidateForm) => {
  if (!refReq.privacyPolicyAgreed) {
    return Pages.Intro;
  } if (!refReq.references.length) {
    return Pages.ReferenceForm;
  }
  return Pages.RefProgressPage;
};

export const getDefaultRefFormPage = (references: IReferenceCandidateForm[]) => (references.length
  ? RefFormPages.Final
  : RefFormPages.Overview);

export const messages: Record<ReferenceType, IFormattedMessage> = {
  [ReferenceType.Manager]: { id: 'review.managersCount.many', defaultMessage: 'Managers' },
  [ReferenceType.Peer]: { id: 'review.peersCount.many', defaultMessage: 'Peers / Colleagues' },
  [ReferenceType.Subordinate]: { id: 'review.subordinatesCount.many', defaultMessage: 'Subordinates' },
  [ReferenceType.Educator]: { id: 'review.educatorsCount.many', defaultMessage: 'Educators' },
  [ReferenceType.Other]: { id: 'review.othersCount.many', defaultMessage: 'Others' }
};

export const ReferenceItem: FunctionComponent<{
  type: ReferenceType;
  provided: number;
  total: number;
 }> = ({ type, provided, total }) => (
   <div className={styles.item} key={type}>
     <div className="d-flex">
       <div className={`mr-2 ${styles.counters}`}>
         {provided}
         {total ? <FormattedMessage id="of">{mes => ` ${mes} ${total}`}</FormattedMessage> : <></>}
       </div>
       <FormattedMessage {...messages[type]} />
     </div>
     {total <= provided
       ? <Check className={styles.icon} />
       : <span className="exclamation-mark"><Exclamation /></span>}
   </div>
 );
